import React ,{useState , useEffect} from 'react';
import "./sidebar.css";
import {
    Link, useHistory, useParams
} from "react-router-dom";
import logo from "../../res/img/logo.png";
import {toast} from 'react-toastify';
import Api from "../../services/api";
import Experience from "../../screen/experience/experience";

const Sidebar = (props) => {
    let history = useHistory()
    const [sidebar , setSidebar] = useState(props.show)
    const [expanded, setExpanded] = useState([])
    const [menuData, setMenuData] = useState([])
    const [experienceMenuData, setExperienceMenuData] = useState([])
    const [postData, setPostData] = useState([])
    const [menuGalleryData, MenuGalleryData] = useState([])

   useEffect(()=>{
       new Api().get("/menu")
           .then((res) => {
               setMenuData(res.result)
           })
           .catch((err) => {
               toast.error(err)
           })
       new Api().get("/menu/gallery")
           .then((res) => {
               MenuGalleryData(res.result)
           })
           .catch((err) => {
               toast.error(err)
           })
       new Api().get("/menu/experience")
           .then((res) => {
               setExperienceMenuData(res.result)
           })
           .catch((err) => {
               toast.error(err)
           })

       new Api().get("/post")
           .then((res) => {
               setPostData(res)
           })
           .catch((err) => {
               toast.error(err)
           })
   } ,[])



    const handleAddExpand = async (value, child) => {
        if (expanded.includes(value)) {
            const newArr = [...expanded]
            const index = expanded.indexOf(value);
            await newArr.splice(index, 1);
            await setExpanded(newArr)
        } else {
            const newArr = [...expanded]
            await newArr.push(value);
            await setExpanded(newArr)
        }

    }
    const handleRoute = (type) => {
        switch (type) {
            case "video" :
                return "gallery"
            case "menu" :
                return "blog"
            case "experience" :
                return "experience"
            case "image" :
                return "report-card"

        }
    }
    const renderBlogTree = (props , route, keyRoute) => {
        // nodes mapping
        const treeNodes = props && props.map((item, key) => {
            // value id node
            const {_id} = item;
            // label title node
            const {title} = item;
            // slug
            const {slug} = item;

            // check has child
            const hasChild =item && item.child && item.child.length > 0;

            // check has child is true fetch children

            const children = hasChild ? renderBlogTree(item.child , route,keyRoute) : '';
            return (
                <>
                    <div
                        className={"tree_view"}>
                        {hasChild === true &&
                        <img onClick={(e) => e.target === e.currentTarget && handleAddExpand(_id, item.child)}
                             src={!expanded.includes(_id) ? "/plus_icon.svg" : "/minus_icon.svg"}/>
                        }
                        <li key={key} className={"tree_box"}>
                          <span
                              className={
                                  hasChild === true
                                      ? 'tree-parent has-child'
                                      : 'tree-parent  has-no-child'
                              }
                          >
                          </span>
                            <div  className={"tree_box_title"}>
                                <div onClick={()=> history.push(`/${handleRoute(item.type) || keyRoute}/category/${_id}`)}> { title}</div>
                            </div>
                            {hasChild === true && (
                                <ul
                                    style={{
                                        display: expanded.includes(_id)
                                            ? 'flex'
                                            : 'none'
                                    }}
                                    className={"tree_children"}
                                >
                                    <div>
                                        {children}
                                    </div>

                                </ul>
                            )}
                        </li>
                    </div>
                </>
            );
        });
        return treeNodes;
    }


    return (
       <div onClick={(e) => {e.target === e.currentTarget && setSidebar(false) ; e.target === e.currentTarget && props.onchange(sidebar)}} className={`sidebar-section ${(props.show ) ? "show-sidebar-section" : "hide-sidebar-section"}`}>
           <div className={`sidebar ${props.show ? "show-sidebar" : "hide-sidebar"}`}>
                    <div className={"sidebar-logo"}>
                        <img src={logo}/>
                    </div>
                    <div className={"sidebar-body"}>
                        <div className={"static"}>
                            <Link to={"/"}>
                                خانه
                            </Link>
                        </div>

                        {
                            menuData && menuData.length > 0 &&
                            <>
                                {renderBlogTree(menuData && menuData , "blog")}
                            </>
                        }
                        {
                            menuGalleryData && menuGalleryData.length > 0 &&
                                <>
                                    {renderBlogTree(menuGalleryData && menuGalleryData , "gallery")}
                                </>
                        }
                        {
                            experienceMenuData && experienceMenuData.length > 0 &&
                                <>
                                    {renderBlogTree(experienceMenuData && experienceMenuData , "experience" , "experience")}
                                </>
                        }
                        <div className={"static"}>
                            <Link to={"/blog"}>
                                درباره هلند
                            </Link>
                        </div>
                        {
                            postData && postData.map((item) => {
                                return (
                                    <div className={"static"}>
                                        <Link to={`/page/${item._id}/${item.title.replace(" ","_")}`}>
                                            {item.title}
                                        </Link>
                                    </div>
                                )
                            })
                        }
                    </div>
           </div>
       </div>
    );
};

export default Sidebar;